export enum HistoryEntityType {
    MATTER = 'MATTER',
    PARTY = 'PARTY',
    EMPLOYEE = 'EMPLOYEE',
    INVOICE = 'INVOICE',
    PARTY_GROUP = 'PARTY_GROUP',
}

export enum HistoryFieldType {
    COMPANY_OFFICIAL_NAME = 'COMPANY_OFFICIAL_NAME',
    MATTER_STATE_TYPE_CODE = 'MATTER_STATE_TYPE_CODE',
    RESPONSIBLE_EMPLOYEE = 'RESPONSIBLE_EMPLOYEE',
    SUPERVISING_EMPLOYEE = 'SUPERVISING_EMPLOYEE',
    RELATIONSHIP_MANAGER_EMPLOYEE = 'RELATIONSHIP_MANAGER_EMPLOYEE',
    IS_ACTIVE = 'IS_ACTIVE',
    RELATIONSHIP_PARTNER_EMPLOYEE = 'RELATIONSHIP_PARTNER_EMPLOYEE',
    RELATIONSHIP_MANAGER = 'RELATIONSHIP_MANAGER',
    RELATIONSHIP_PARTNER = 'RELATIONSHIP_PARTNER',
    RECEIVABILITY_TYPE_CODE = 'RECEIVABILITY_TYPE_CODE',
    MEMBER = 'MEMBER',
    NAME = 'NAME',
    PARTNERSHIP_PEER_GROUP_TYPE_CODE = 'PARTNERSHIP_PEER_GROUP_TYPE_CODE',
    PARTY_GROUP = 'PARTY_GROUP',
    PERSON_OFFICIAL_NAME = 'PERSON_OFFICIAL_NAME',
    SEGMENT_TYPE_CODE = 'SEGMENT_TYPE_CODE',
    SERVICE_LEVEL_TYPE_CODE = 'SERVICE_LEVEL_TYPE_CODE',
}

export enum HistoryRecordState {
    EDITING = 'EDITING',
    VIEWING = 'VIEWING',
}

export interface HistoryDto {
    id: number;
    entityType: string;
    entityId: string;
    fieldType: string;
    fieldValue: string;
    startDate: string;
    endDate: string;
}

export interface UpdateHistoryDto {
    startDate: string | null;
    endDate: string | null;
}

export interface HistoryEntityDto {
    id: number;
    entityId: string;
}

export interface HistoryForm {
    id: number;
    entityType: string;
    entityId: string;
    fieldType: string;
    fieldValue: string;
    startDate: string;
    endDate: string | null;
    recordState: HistoryRecordState;
}

export const getClassifierCode = (fieldType: string): string | null => {
    switch (fieldType) {
        case HistoryFieldType.MATTER_STATE_TYPE_CODE:
            return 'MATTER_STATE_TYPE';
        case HistoryFieldType.SEGMENT_TYPE_CODE:
            return 'SEGMENT_TYPE';
        case HistoryFieldType.SERVICE_LEVEL_TYPE_CODE:
            return 'SERVICE_LEVEL_TYPE';
        case HistoryFieldType.RECEIVABILITY_TYPE_CODE:
            return 'RECEIVABILITY_TYPE';
        case HistoryFieldType.PARTNERSHIP_PEER_GROUP_TYPE_CODE:
            return 'PARTNERSHIP_PEER_GROUP_TYPE';
        default:
            return null;
    }
};
